import React from 'react';

export default function ArrowLeft() {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.50001 11.625H19.5V12.375H4.50001V11.625Z" />
      <path d="M10.6465 5.14645L11.3536 5.85355L5.20712 12L11.3536 18.1464L10.6465 18.8536L3.79291 12L10.6465 5.14645Z" />
    </svg>
  );
}
